(function () {
    'use strict';

    angular.module("imApp").factory("discGrpProdService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3113,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3114,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
